import {
  UPDATE_CHECK_ERROR,
  UPDATE_RESERVATION_RESPONSE,
  UPDATE_CHECK_DATA,
  UPDATE_SCAN_BACK_RESPONSE,
  UPDATE_SCAN_FRONT_RESPONSE,
  CLEAN_CHECK_STATE,
  SET_CHECK_REQUEST_LOADING,
  CLEAN_CHECK_SCAN_ERROR,
  UPDATE_BACK_PHOTO,
  UPDATE_FRONT_PHOTO,
  SHOW_CONFIRM_AMOUNT_DIALOG,
  SET_CHECK_SCAN_PAYMENT_CONFIRMED,
  SET_DUPLICATE_ORDER_ID,
  PROCESS_FRONT_CHECK_SCAN_IMAGE,
  PROCESS_BACK_CHECK_SCAN_IMAGE,
} from "../../actionTypes/check";

export function updateCheckData(checkData: any) {
  return { type: UPDATE_CHECK_DATA, payload: checkData };
}

export function updateScanFrontResponse(response: any) {
  return { type: UPDATE_SCAN_FRONT_RESPONSE, payload: response };
}

export function updateScanBackResponse(response: any) {
  return { type: UPDATE_SCAN_BACK_RESPONSE, payload: response };
}

export function updateReservationResponse(response: any) {
  return { type: UPDATE_RESERVATION_RESPONSE, payload: response };
}

export function updateError(error: any) {
  return { type: UPDATE_CHECK_ERROR, payload: error };
}

export function cleanError() {
  return { type: CLEAN_CHECK_SCAN_ERROR };
}

export function cleanState() {
  return { type: CLEAN_CHECK_STATE, payload: {} };
}

export function setCheckRequestIsLoading(isLoading: any) {
  return { type: SET_CHECK_REQUEST_LOADING, payload: isLoading };
}

export function updateFrontPhoto(photo: any) {
  return { type: UPDATE_FRONT_PHOTO, payload: photo };
}

export function updateBackPhoto(photo: any) {
  return { type: UPDATE_BACK_PHOTO, payload: photo };
}

export function showConfirmAmountDialog(showDialog: boolean) {
  return { type: SHOW_CONFIRM_AMOUNT_DIALOG, payload: showDialog };
}

export function setCheckScanPaymentConfirmed(confirmed: boolean) {
  return { type: SET_CHECK_SCAN_PAYMENT_CONFIRMED, payload: confirmed };
}

export function setDuplicateOrderId(orderId: string) {
  return { type: SET_DUPLICATE_ORDER_ID, payload: orderId };
}
export function processFrontCheckScanImage(processFrontImage: boolean) {
  return { type: PROCESS_FRONT_CHECK_SCAN_IMAGE, payload: processFrontImage };
}

export function  processBackCheckScanImage(processBackImage: boolean){
  return { type: PROCESS_BACK_CHECK_SCAN_IMAGE, payload: processBackImage };
}
